<template>
    <div>
        <nav-breadcrumb :menu="[{label: '发起撤押用印申请'}]"/>
        <panel  label="基本信息">
            <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24" >
                        <el-form-item label="用印类型：" prop="t__applicationTypeCode" :rules="{required: true, message: '不能为空'}">
                            <el-select placeholder="请选择类型" v-model.trim="dataForm.t__applicationTypeCode" disabled>
                                <el-option label="撤押用印" value="CY" ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="用印日期：" prop="t__applicationDate" :rules="{required: true, message: '不能为空'}">
                            <el-date-picker
                                v-model="dataForm.t__applicationDate"
                                value-format="yyyy-MM-dd hh:mm:ss"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="所需盖章：" prop="t__companySeal" :rules="{required: true, message: '不能为空'}">
                            <el-checkbox  v-model="dataForm.t__companySeal" true-label="Y" false-label="N" >公章</el-checkbox>
                            <el-checkbox  v-model="dataForm.t__legalRepSeal" true-label="Y" false-label="N" >法人章</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="用印描述：" style="width: 60%">
                            <el-input type="textarea" v-model="dataForm.t__remarks" style="margin-bottom:10px;" ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </panel>
        <panel >
            <div class="panel-flex-between">
                <div class="Htitle-text">关联信息</div>
                <i class="el-icon-circle-plus" @click="addDetail()" style="transform: scale(2);cursor: pointer;color:#409EFF;"></i>
            </div>

            <panel v-for="(item,idx) in dataForm.detail"
                   :key="`panel_${idx}`"
                   style="border:solid 1px #ddd">
                <panel >
                    <div class="panel-flex-between">
                        <div class="Htitle-text">贷款信息</div>
                        <i class="el-icon-remove" @click="deleteDetail(idx)" style="transform: scale(2);cursor: pointer;color:#409EFF;"></i>
                    </div>
                    <el-form :model="item" label-width="170px" class="xzformitemmb" ref="dataForm1" >
                        <el-row>
                            <panel border>
                                <el-col :span="12">
                                    <el-form-item label="贷款编号 ：" prop="d__disabled" :rules="{required: true, message: '不能为空'}">
                                        {{item.fi__transactionNo}}&nbsp;&nbsp;&nbsp;<el-button  type="primary" size="mini"  @click="selectFinance(idx)">选择</el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款状态：">
                                        {{(item.fi__transactionStatus?('Financing_'+ item.fi__transactionStatus):'')|Status2CN}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="客户名称：">
                                        {{item.fi__customerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="渠道商：">
                                        {{item.d__dealerName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款金额：">
                                        {{item.fi__totalAmount|formatMoney}} 元
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="贷款产品：">
                                        {{item.ct__productName}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款开始日期：">
                                        {{item.fi__startDate|moment('YYYY-MM-DD')}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="贷款结束日期：">
                                        {{item.fi__endDate|moment('YYYY-MM-DD')}}
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="贷款合同利率：">
                                        {{item.fi__interestRate}}% （{{item.fi__interestType|Status2CN}}）
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="留存收益率：">
                                        {{item.dfi__interestRate}}% （{{item.dfi__interestType|Status2CN}}）
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="贷款合同月利率：">
                                        {{item.monthRate}}‰
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="还款期数（月）：">
                                        {{item.fi__repaymentCount}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="还款方式：">
                                        {{item.fi__repaymentFormula|Status2CN}}
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="贷款用途：" >
                                        {{item.fi__intendedUse}}
                                    </el-form-item>
                                </el-col>



                            </panel>
                        </el-row>
                    </el-form>
                </panel>
                <panel title="盖章文件">
                    <files-upload :file-list.sync="dataForm.detail[idx].fileList" :max="100" :allow-file-ext="['PDF', 'Word', 'Excel', 'JPG', 'PNG', 'BMP', 'GIF', 'RAR', 'ZIP']" :additional-columns="additionalColumns"></files-upload>
                </panel>
            </panel>

        </panel>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
        <el-dialog title="选择"
                   :visible.sync="dialogVisible" @close="dataRelaod()">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    import Panel from "../../components/Panel";
    import {formatMoney} from "../../filters/CommonFilters";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    export default  {
        name: "ContractSealProcess",
        data(){
            return {
                applicationId: this.$route.query['applicationId']||'',
                dataForm: {
                    t__companySeal:'Y',
                    t__legalRepSeal:'Y',
                    t__applicationTypeCode:'CY',
                    t__applicationDate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    detail:[{
                        fileList: [],
                    }]
                },
                bankFormFiles: [],
                dataFormRules: {},
                dialogVisible:false,
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions:[],
                filters: {
                    labelWidth: '150px',
                    form: {
                        fi__transactionNo:'',
                        fi__customerName:'',
                        /* c__customerContactNo:'',
                         d__dealerId:'',
                         fi__transactionDate:[],
                         fi__transactionStatus:'',
                         fi__repaymentFormula:'',
                         overdue:'',*/
                    },
                    columns: [
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'fi__transactionNo',

                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'fi__customerName',
                            span:12

                        },


                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                },
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '贷款编号',
                        field: 'fi__transactionNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'fi__customerName'
                    },
                    {
                        label: '操作',
                        opts:[

                            {
                                class: 'el-icon-check',
                                name: '选择',
                                clickHandler: (index, row)=>{
                                    if(this.selectKeys>-1){
                                        let item = this.dataForm.detail[this.selectKeys]
                                        item.fi__transactionNo = row.fi__transactionNo
                                        item.fi__transactionStatus = row.fi__transactionStatus
                                        item.fi__customerName = row.fi__customerName
                                        item.d__dealerName = row.d__dealerName
                                        item.fi__totalAmount = row.fi__totalAmount
                                        item.ct__productName = row.ct__productName
                                        item.fi__startDate = row.fi__startDate
                                        item.fi__endDate = row.fi__endDate
                                        item.fi__interestRate = row.fi__interestRate
                                        item.fi__interestType = row.fi__interestType
                                        item.dfi__interestType = row.dfi__interestType
                                        item.dfi__interestRate = row.dfi__interestRate
                                        if(row.ct__interestType === 'Yearly'){
                                            item.monthRate = (row.fi__interestRate/12)
                                        }
                                        if(row.ct__interestType === 'Monthly'){
                                            item.monthRate = row.fi__interestRate
                                        }if(row.ct__interestType === 'Daily'){
                                            item.monthRate = (row.fi__interestRate*30)
                                        }

                                        item.monthRate = parseFloat((parseFloat(item.monthRate)*10).toFixed(3))

                                        item.fi__repaymentCount = row.fi__repaymentCount
                                        item.fi__repaymentFormula = row.fi__repaymentFormula
                                        item.fi__intendedUse = row.fi__intendedUse
                                        item.de__referenceId = row.fi__transactionId
                                        item.de__checked = true
                                        this.dialogVisible = false
                                    }

                                }
                            }
                        ]
                    }
                ],
                additionalColumns: [
                    {
                        label: '盖章份数',
                        field: 'copies',
                        component: 'el-input',
                        type: 'number',
                        props: {
                            step: 1
                        },
                    }
                ],
                selectKeys:-1,
            }
        },
        filters: {

            Status2CN
        },
        computed:{
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                        'xlist.search.fi.transactionStatus' : 'Processing,Ready,Settled',
                        'xlist.search.fi.transactionStatus.op' : 'in',
                        'xlist.sort.dataField': 'fi.startDate',
                        'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        mounted() {
            if(this.applicationId){
                this.getData2()
            }
        },
        methods: {
            getData2:function(){
                xhr.getViewSealApplication({
                        't.applicationId': this.applicationId
                    },
                    res=> {
                        try{
                            if(res.data.status === 'success') {
                                const dataForm = res.data.data
                                dataForm.detail.forEach((item, idx)=>{
                                    xhr.getFinancingFangSelect(
                                        Object.assign({
                                            'xlist.search.fi.transactionId' : item.de__referenceId,
                                            'xlist.search.fi.transactionId.op' : 'in',
                                        }, {},{}),
                                        res => {
                                            try {
                                                let row = res.data.data[0]
                                                item.fi__transactionNo = row.fi__transactionNo
                                                item.fi__transactionStatus = row.fi__transactionStatus
                                                item.fi__customerName = row.fi__customerName
                                                item.d__dealerName = row.d__dealerName
                                                item.fi__totalAmount = row.fi__totalAmount
                                                item.ct__productName = row.ct__productName
                                                item.fi__startDate = row.fi__startDate
                                                item.fi__endDate = row.fi__endDate
                                                item.fi__interestRate = row.fi__interestRate
                                                item.fi__interestType = row.fi__interestType
                                                item.dfi__interestType = row.dfi__interestType
                                                item.dfi__interestRate = row.dfi__interestRate
                                                if(row.ct__interestType === 'Yearly'){
                                                    item.monthRate = (row.fi__interestRate/12)
                                                }
                                                if(row.ct__interestType === 'Monthly'){
                                                    item.monthRate = row.fi__interestRate
                                                }if(row.ct__interestType === 'Daily'){
                                                    item.monthRate = (row.fi__interestRate*30)
                                                }

                                                item.monthRate = parseFloat((parseFloat(item.monthRate)*10).toFixed(3))

                                                item.fi__repaymentCount = row.fi__repaymentCount
                                                item.fi__repaymentFormula = row.fi__repaymentFormula
                                                item.fi__intendedUse = row.fi__intendedUse
                                                item.de__referenceId = row.fi__transactionId

                                                this.$set(item, 'fileList', [])
                                                item.de__docs.forEach(items=>{
                                                    item.fileList.push({
                                                        'name':items.fileName,
                                                        'size':items.fileSize,
                                                        'fileId':items.fileURL,
                                                        'copies':items.copies,
                                                    })
                                                })
                                                this.dataForm = dataForm
                                                this.$set(this.dataForm.detail, idx, item)
                                            } catch (e) {

                                            }
                                        })

                                })



                            }
                        }catch (e) {

                        }
                    })
            },
            Status2CN,
            addDetail:function () {
                this.dataForm.detail.push({
                    fileList: []
                })
            },
            deleteDetail:function (index) {
                this.dataForm.detail.splice(index,1)
            },
            selectFinance:function (index) {

                this.selectKeys = index
                this.dialogVisible = true
                this.getData()

            },
            dataRelaod:function () {
                this.selectKeys = -1
            },
            getData: function () {
                xhr.getFinancingFangSelect(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res => {
                        try {
                            this.tableData = res.data
                        } catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        let next = true
                        dataForm.detail.forEach(item=>{
                            if(item.de__referenceId){

                            }else{
                                this.$alert('有贷款未选择')
                                next =  false
                            }
                            if(item.fileList.length===0){
                                this.$alert('盖章文件未上传全')
                                next =  false
                            }else{

                            }
                            let doc = []
                            item.fileList.forEach(items=>{
                                doc.push({
                                    'fileName':items.name,
                                    'fileSize':items.size,
                                    'fileURL':items.fileId,
                                    'copies':items.copies,
                                })
                            })
                            item.de__docs = doc
                        })
                        if(this.dataForm.t__legalRepSeal ==='N'){
                            this.$confirm(`您未勾选“法人章”，请确认不需要盖”法人章”吗?`)
                                .then(() => {
                                    if(next){
                                        dataForm.t__applicationId = ''
                                        dataForm.t__checked = true
                                        dataForm['t.applicationDate.dateformat'] = 'yyyy-MM-dd hh:mm:ss'
                                        xhr.saveSealApplicationForApproval(
                                            dataForm,
                                            res=> {
                                                try{
                                                    if(res.data.status === 'success') {

                                                    }else{

                                                        this.$message.error(res.data.msgs[0].text)
                                                    }
                                                    this.$router.push({
                                                        name: 'ContractSealProcessListView'
                                                    })
                                                }catch (e) {

                                                    this.$message.error(error.msgs[0].text)

                                                }
                                            }
                                        )
                                    }
                                })
                                .catch(() => {

                                })
                        }else {
                            if(next){
                                dataForm.t__applicationId = ''
                                dataForm.t__checked = true
                                dataForm['t.applicationDate.dateformat'] = 'yyyy-MM-dd hh:mm:ss'
                                xhr.saveSealApplicationForApproval(
                                    dataForm,
                                    res=> {
                                        try{
                                            if(res.data.status === 'success') {

                                            }else{

                                                this.$message.error(res.data.msgs[0].text)
                                            }
                                            this.$router.push({
                                                name: 'ContractSealProcessListView'
                                            })
                                        }catch (e) {

                                            this.$message.error(error.msgs[0].text)

                                        }
                                    }
                                )
                            }
                        }


                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ContractSealProcessCY.vue